import HospitalUserProfileDTO from '@src/adapters/dto/hospital/HospitalUserProfileDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  userId: string;
  hospitalId: string;
  firstName: string;
  lastName: string;
  professionalBodyId?: string;
  roles: string[];
  registrationNumber?: string;
}

type Result = HospitalUserProfileDTO;

const options: ApiOptions = {
  method: 'patch',
  urlPath: '/hospital/user/update',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useUpdateHospitalUser = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useUpdateHospitalUserLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useUpdateHospitalUser;
